import { useEffect } from "react"

/**
 * A hook which allows you to listen for events.
 */
export const useEventListener = (event: string, handler?: () => unknown) => {
    useEffect(() => {
        if (!handler) {
            return
        }

        window.addEventListener(event, handler)

        return () => {
            window.removeEventListener(event, handler)
        }
    }, [event, handler])
}
